<template>
  <div class="pie-chart">
    <h2 v-if="headline" class="pie-chart__title">{{ headline }}</h2>
    <slot name="content"></slot>
    <div class="pie-chart__container">
      <canvas class="pie-chart__canvas" ref="chart"></canvas>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'

  export default {
    name: 'pie-chart',
    props: {
      headline: {
        type: String,
      },
      dataSource: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        config: {
          type: 'pie',
          options: {
            maintainAspectRatio: false,
            fontColor: '#dddddd',
            responsive: true,
            legend: {
              position: 'left',
              maxWidth: 100,
              display: true,
              labels: {
                filter: (item) => {
                  return item.index < 6
                },
              },
            },
            tooltips: {
              mode: 'index',
              callbacks: {
                label: (item, data) => {
                  const dataset = data.datasets[item.datasetIndex]
                  const value = dataset.data[item.index].toFixed(1)
                  const label = data.labels[item.index]

                  if (label.toLowerCase().includes('kwh')) {
                    return label
                  }

                  return `${label} (${value} kWh)`
                },
              },
            },
          },
          data: {
            labels: [],
            datasets: [
              {
                fill: 'origin',
                backgroundColor: process.env.VUE_APP_SCSS_COLOR_COMMUNITY,
                data: [],
              },
            ],
          },
        },
      }
    },
    mounted() {
      this.updateChart(this.chartData)
    },
    computed: {
      chartData() {
        return this.$store.getters.tradingStatistics(this.dataSource)
      },
    },
    methods: {
      updateChart: function (data) {
        // Dont show/update the chart without any data.
        if (data.labels.length < 1) {
          return false
        }

        if (!this.chart) {
          let chartSettings = {
            ...this.config,
          }

          chartSettings.data.labels = data.labels
          chartSettings.data.datasets[0].data = data.data
          chartSettings.data.datasets[0].backgroundColor = data.backgroundColor

          this.chart = new Chart(this.$refs.chart, chartSettings)
        } else {
          this.chart.data.labels = data.labels
          this.chart.data.datasets[0].data = data.data
          this.chart.data.datasets[0].backgroundColor = data.backgroundColor
          this.chart.update()
        }
      },
    },
    watch: {
      chartData(newData) {
        this.updateChart(newData)
      },
    },
  }
</script>

<style lang="scss">
  .pie-chart {
    &__title {
      margin-bottom: spacer(0.1);
    }

    &__content {
      margin-bottom: spacer(1);
    }
  }
</style>
